<template>
    <b-card :style="{'max-width': '1500px', 'width': '95%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
        <b-card-text>
            <h4>My Customer Deliveries</h4>
        </b-card-text>

        <b-card-text>
            <p>LOCATION</p>
            <b-form-select :options="get_applicable_locations()" style="width: 200px;" v-model="location_id" v-on:change="fetch_dates"></b-form-select>
        </b-card-text>

        <div v-if="location_id">
            <b-card-group deck>
                <b-card header="DELIVERY DATES" style="height: 70%; max-width: 13rem; min-width: 13rem; text-align: center; overflow: scroll;">
                    <div v-if="dates.length == 0">
                        No Delivery Dates Found.
                    </div>

                    <div v-else>
                        <b-list-group>
                            <b-list-group-item button v-for="dt, didx in dates" v-bind:key="didx" :active="is_clicked_didx(didx)" @click="didx_clicked(didx)">{{dt.dt}} ({{dt.count}})</b-list-group-item>
                        </b-list-group>
                    </div>
                </b-card>

                <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
                    <b-card header="DELIVERIES" style="height: auto; min-width: 50rem; text-align: center; overflow: scroll;" v-if="items.length > 0">
                        
                        <b-card v-for="item, idx in items" v-bind:key="idx">
                            <h6>{{ item.invoice_id }}</h6>

                            <b-card-text style="text-align: left; margin-right: auto;">
                                <b-alert variant="secondary" show style=" font-size: 11px;">
                                    <div>Name: {{ item.fullname }}</div>
                                    <div>Address: {{ item.address_line_1 }} {{ item.address_line_2 }} (ZIP {{ item.zipcode }})</div>
                                    <div>Phone: {{ item.phone_1 }}</div>
                                </b-alert>

                            </b-card-text>

                            <b-table :bordered="true" :small="true" :items="item.items" style="font-size: 11px;" :fields="['delivery_date', 'product_name', 'refunded', 'truck']"></b-table>
                        </b-card>

                    </b-card>
                </b-overlay>
            </b-card-group>
        </div>

    </b-card>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    export default {
        name: "MyCustomerDeliveries",
        components: {Backer, flatPickr},
        data: function(){
            return {
                packet: {},
                items: [],
                items_being_loaded: false,
                dates: [],
                date: null,
                location_id: null,
                clicked_didx: null,
            }
        },
        methods: {
            is_clicked_didx: function(didx){
                if (didx == this.clicked_didx){
                    return true
                }
                else {
                    return false
                }
            },
            didx_clicked: function(didx){
                this.clicked_didx = didx;
                this.date = this.dates[didx].dt;

                let path = "/api/sales/get_my_customer_deliveries/"
                let data = {location_id: this.location_id, delivery_date: this.date}
                let that = this;
                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.items = response.data.result;
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error) {
                    that.$bvToast.toast(
                        "Error loading deliveries. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded = true;
                Requestor.getSync(path, data, s, f);

            },
            get_applicable_locations: function(){
                let userrole = this.packet.userDetails.userrole;
                if (userrole == 'admin' || userrole == 'officeuser'){
                    return this.packet.locations
                }
                else {

                    let location_id = this.packet.userDetails.properties.location_id;
                    return this.packet.locations.filter(function(d){return d.value == location_id});
                }
            },
            fetch_dates: function(location_id){
                let path = "/api/sales/get_my_customer_deliveries_date_counts/"
                let data = {location_id: location_id}
                let that = this;
                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.dates = response.data.result;
                    }
                }
                let f = function(error) {
                    that.$bvToast.toast(
                        "Error loading delivery dates. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
                Requestor.getAsync(path, data, s, f);
                
            }
            
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
        }
    }
</script>

<style scoped>
    .non-header {
        font-weight: normal;
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Sales/MyCustomerDeliveries.vue